import { useContext, useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { NoPage } from '@shared/pages';
import { StatusLabel } from '@shared/components';
import { useDocumentTitle } from '@shared/hooks';
import { isTFolder, TFolder, TPath, useFolder } from '@modules/items';
import { SignInContext } from '@modules/users';

import ChangeDashboard from '../components/ChangeDashboard';
import { getChangeDashboardPath, isChangeMockVisible } from '../helpers';

const buildFullPath = (folder: TFolder): TPath => [
  ...folder.resolvedPath,
  { _id: folder._id, name: folder.name, accessRight: folder.accessRight },
  { _id: 'changes', name: 'Changes', accessRight: folder.accessRight, href: getChangeDashboardPath() },
];

const MockChanges = () => {
  const { productId } = useParams();
  const { organization } = useContext(SignInContext);
  const config = organization.mock?.change;
  const folderId = productId ?? organization.folders.qm;
  const isVisible = isChangeMockVisible(config) && Boolean(folderId);

  const { error, data } = useFolder(folderId, { enabled: isVisible });

  useDocumentTitle('Changes');

  const scope = productId ? 'product' : 'company';
  const fullPath = useMemo(() => (data && isTFolder(data) ? buildFullPath(data as TFolder) : undefined), [data]);

  if (!isVisible || !config) return <NoPage />;

  return (
    <StatusLabel
      data={data}
      loadingMessage="Loading changes..."
      error={error}
      errorMessage="Loading changes failed!"
      render={(resolvedData) =>
        isTFolder(resolvedData) && fullPath ? (
          <ChangeDashboard folder={resolvedData as TFolder} fullPath={fullPath} config={config} scope={scope} />
        ) : (
          <NoPage />
        )
      }
    />
  );
};

export default MockChanges;
